namespace SP {
    export enum ShipmentState {
        ReturnPending = 1,
        ReturnReceived = 2,
        ReturnFinished = 3,
        ReturnCanceled = 4,
    }
}